/* eslint-disable react/self-closing-comp */
import clsx from 'clsx'
import React from 'react'
import { BasicStyledComponent } from 'shared-definitions/types'
import { useScrollableLinksContainer } from '../hooks/use-scrollbale-links-container'

interface ViafouraConversationStarterProps extends BasicStyledComponent {
  containerId: string
  title?: string
  description?: string
  minimumCommentCount?: number
}

const ViafouraConversationStarter: React.FC<ViafouraConversationStarterProps> = ({
  className,
  containerId,
  title,
  description,
  minimumCommentCount,
}) => {
  const scrollableLinksRef = useScrollableLinksContainer<HTMLDivElement>()

  return (
    <div className={clsx('viafoura', className)} ref={scrollableLinksRef}>
      <vf-conversation-starter
        vf-container-id={containerId}
        minimum-comment-count={minimumCommentCount}
        target="comments-section"
        title={title}
        description={description}
      ></vf-conversation-starter>
    </div>
  )
}

export default ViafouraConversationStarter
